<div class="modal-header">
  <h4 class="modal-title pr-1" id="modal-basic-title">Joindre un conseiller par téléphone</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
<div class="row mt-1">
  <div id="number1" class="col-6 pr-4">
    <div class="phoneNumber">{{ phones?.get('number1').phoneNumber }}</div>
    <div class="phoneLabel">{{ phones?.get('number1').text }}</div>
  </div>
  <div id="etranger" class="col-6 pr-4" *ngIf="phones?.get('stranger')">
    <div class="phoneNumber">{{ phones?.get('stranger').phoneNumber }}</div>
    <div class="phoneLabel">{{ phones?.get('stranger').text }}</div>
  </div>
</div>

<div class="row mt-1">
  <div id="number2" class="col-6 pr-4" *ngIf="phones?.get('number2')">
    <div class="phoneNumber">{{ phones?.get('number2').phoneNumber }}</div>
    <div class="phoneLabel">{{ phones?.get('number2').text }}</div>
  </div>
  <div id="number3" class="col-6 pr-4" *ngIf="phones?.get('number3')">
    <div class="phoneNumber">{{ phones?.get('number3').phoneNumber }}</div>
    <div class="phoneLabel">{{ phones?.get('number3').text }}</div>
  </div>
</div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-info" (click)="activeModal.dismiss()">Fermer</button>
</div>

